import { useQuery } from "@tanstack/react-query";
import { getUser } from "../services/auth.service";
import { IUser } from "../types/auth.types";
import { getAccessToken } from "../utils/storage.utils";

export const useUser = () => {
  const {
    data: user,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<IUser>({
    queryKey: ["user"],
    queryFn: async () => {
      // Check if token exists before making the API call
      const token = await getAccessToken();
      if (token == null) {
        throw new Error("No access token available");
      }
      return getUser();
    },
    retry: false,
    refetchOnMount: false, // Don't refetch on mount if data is fresh
  });

  const isAuthenticated = !!user && !isError;

  return {
    user,
    isAuthenticated,
    isLoading,
    isError,
    error,
    refetch,
  };
};

export default useUser;
